import React from 'react';

interface InputSummaryProps {
  attachments: Array<{ name: string }>;
  selectedTemplateName: string;
  selectedPatient: string; // This will be the patient name for display
  onProcessAnother: () => void;
}

export const InputSummary: React.FC<InputSummaryProps> = ({
  attachments,
  selectedTemplateName,
  selectedPatient,
  onProcessAnother
}) => {
  return (
    <div className="input-summary">
      <div className="input-summary__content">
        <div className="input-summary__icon">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
            <path d="M8 0a8 8 0 100 16A8 8 0 008 0zM7 3a1 1 0 112 0v4a1 1 0 11-2 0V3zm1 8a1 1 0 100-2 1 1 0 000 2z"/>
          </svg>
        </div>
        <div className="input-summary__details">
          <div className="input-summary__files">
            {attachments.length} file{attachments.length !== 1 ? 's' : ''} processed: {attachments.map(f => f.name).join(', ')}
          </div>
          <div className="input-summary__template">
            Template: {selectedTemplateName}
          </div>
          {selectedPatient && (
            <div className="input-summary__patient">
              Patient: {selectedPatient}
            </div>
          )}
        </div>
        <button 
          className="input-summary__process-another"
          onClick={onProcessAnother}
        >
          New Task
        </button>
      </div>
    </div>
  );
}; 